import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Ruta_Sesion } from 'generated/graphql';

const initialState: Ruta_Sesion[] | null = null as any;

const rutaSesionesCachedStateSlice = createSlice({
	name: 'rutaSesionesCachedState',
	initialState,
	reducers: {
		setRutaSesionesCacheState: (state, action: PayloadAction<Ruta_Sesion[] | null>) => {
			return action.payload;
		}
	}
});

export const { setRutaSesionesCacheState } = rutaSesionesCachedStateSlice.actions;

export default rutaSesionesCachedStateSlice.reducer;
